import { Link } from 'react-router-dom';

export function CheckoutSuccess() {
  return (
    <div className="max-w-lg mx-auto mt-20 md:mt-32 px-4 text-center">
      <div className="eyebrow text-brand mb-3">Paid</div>
      <h1 className="font-display text-5xl mb-4">Thanks for your support.</h1>
      <p className="text-ink-2">A receipt is on its way.</p>
      <Link to="/profile" className="btn-outline mt-8">
        View your orders
      </Link>
    </div>
  );
}

export function CheckoutCancel() {
  return (
    <div className="max-w-lg mx-auto mt-20 md:mt-32 px-4 text-center">
      <div className="eyebrow mb-3">Cancelled</div>
      <h1 className="font-display text-5xl mb-4">No charge was made.</h1>
      <p className="text-ink-2">Come back when you're ready.</p>
      <Link to="/shop" className="btn-outline mt-8">
        Back to shop
      </Link>
    </div>
  );
}

export function RentalConfirmed() {
  return (
    <div className="max-w-lg mx-auto mt-20 md:mt-32 px-4 text-center">
      <div className="eyebrow text-brand mb-3">Confirmed</div>
      <h1 className="font-display text-5xl mb-4">Your rental is booked.</h1>
      <p className="text-ink-2">A confirmation is on its way by email. See you at the clubhouse.</p>
    </div>
  );
}
